import * as React from "react";
import CustomRuleTable from "./CustomRuleTable";
import { useCallback, useEffect, useState } from "react";
import api from "../../api";
import "./style.css";
import PageHeader from "../layout/PageHeader";
import { PrimaryButton, Pivot, PivotItem } from "@fluentui/react";
import CustomRuleDialog from "./CustomRuleDialog";
import Pagination from "../base/Pagination";
import EurocodeExceptions from "./eurocodeExceptions";
import { useLocation, useNavigate } from "react-router";
import NavigationHelper from "../utils/NavigationHelper";

interface CustomRuleTableColumn {
    name: string;
}

const ruleTableColumns: CustomRuleTableColumn[] = [
    { name: "#" },
    { name: "Regl Navn" },
    { name: "Bilmærke" },
    { name: "Bil Model" }
];

const ruleSetColumns: CustomRuleTableColumn[] = [
    { name: "#" },
    { name: "Reglsæt Navn" }
];



const TAB_RULE_SET = "regelsat";
const TAB_EUROCODE = "eurocode";

const DepartmentRuleSet: React.FunctionComponent = props => {
    const navigate = useNavigate();
    const location = useLocation();
    const activeTab = location.pathname.endsWith("/eurocode") ? TAB_EUROCODE : TAB_RULE_SET;

    const handleTabChange = (item?: PivotItem) => {
        if (item && item.props.itemKey === TAB_EUROCODE) {
            navigate(NavigationHelper.getRoute("DEPARTMENT_RULE_SET_EUROCODE"));
        } else {
            navigate(NavigationHelper.getRoute("DEPARTMENT_RULE_SET"));
        }
    };

    const [rules, setRules] = useState<Rule[]>([]);
    const [ruleSets, setRuleSets] = useState<RuleSet[]>([]);

    const [rulesPageSize, setRulesPageSize] = useState(10);
    const [rulesSetPageSize, setRuleSetsPageSize] = useState(10);
    const [rulesPage, setRulesPage] = useState(0);
    const [ruleSetsPage, setRuleSetsPage] = useState(0);
    const [rulesTotalPages, setRulesTotalPages] = useState(0);
    const [ruleSetsTotalPages, setRuleSetsTotalPages] = useState(0);

    const [showNewRuleDialog, setShowNewRuleDialog] = useState<boolean>(false);
    const [showNewRuleSetDialog, setShowNewRuleSetDialog] = useState<boolean>(
        false
    );

    const fetchRules =  () => {
        api.DepartmentRuleSetApi.getRulesPaginated(rulesPageSize, rulesPage).then(
            data => {
                setRules(data.rules);
                setRulesTotalPages(data.totalPages);
            }
        );
    }

    const fetchRuleSets = () => {
        api.DepartmentRuleSetApi.getRuleSets(rulesSetPageSize, ruleSetsPage).then(
            data => {
                setRuleSets(data.ruleSets);
                setRuleSetsTotalPages(data.totalPages);
            }
        );
    }
    
    useEffect(() => {
        function handleRuleSetRefreshEvent () {
            fetchRuleSets();
        }

        document.addEventListener('RULESET_REFRESH', handleRuleSetRefreshEvent)
        
        return () => {
            document.removeEventListener('RULESET_REFRESH', handleRuleSetRefreshEvent)
        }
    }, [])

    useEffect(() => {
        function handleRulesRefreshEvent () {
            fetchRules();
        }

        document.addEventListener('RULES_REFRESH', handleRulesRefreshEvent)
        
        return () => {
            document.removeEventListener('RULES_REFRESH', handleRulesRefreshEvent)
        }
    })

    useEffect(() => {
        fetchRules();
    }, [rulesPage]);

    useEffect(() => {
        fetchRuleSets();
    }, [ruleSetsPage]);

    const onToggleNewRuleDialog = useCallback(() => {
        setShowNewRuleDialog(!showNewRuleDialog);
    }, [showNewRuleDialog]);

    const onToggleNewRuleSetDialog = useCallback(() => {
        setShowNewRuleSetDialog(!showNewRuleSetDialog);
    }, [showNewRuleSetDialog]);

    return (
        <>
            <PageHeader
                currentPage={"Undtagelser"}
                noBreadcrumb={true}
            />
            <Pivot selectedKey={activeTab} onLinkClick={handleTabChange}>
                <PivotItem headerText="Afdeling reglersæt" itemKey={TAB_RULE_SET}>
            <div className="rules__container">
                <div>
                    <div className="custom__table_header">
                        <p>Regler</p>
                        <PrimaryButton
                            className="custom__table_button"
                            onClick={onToggleNewRuleDialog}
                        >
                            {" Opret ny regl"}
                        </PrimaryButton>
                    </div>
                    <div className="rules__table">
                        <CustomRuleTable
                            data={rules}
                            columns={ruleTableColumns}
                            rule={true}
                        />
                        <Pagination
                            updatePagination={setRulesPage}
                            currentPage={rulesPage}
                            pages={rulesTotalPages}
                        />
                    </div>
                    <CustomRuleDialog isRuleDialog={true} hidden={!showNewRuleDialog} onToggleDialog={onToggleNewRuleDialog}></CustomRuleDialog>
                </div>
                <div>
                    <div className="custom__table_header">
                        <p>Reglsæt</p>

                        <PrimaryButton
                            className="custom__table_button"
                            onClick={onToggleNewRuleSetDialog}
                        >
                            {" Opret ny reglsæt"}
                        </PrimaryButton>
                    </div>
                    <div className="ruleSet__table">
                        <CustomRuleTable
                            data={ruleSets}
                            columns={ruleSetColumns}
                            rule={false}
                        />
                    </div>
                    <Pagination
                        updatePagination={setRuleSetsPage}
                        currentPage={ruleSetsPage}
                        pages={ruleSetsTotalPages}
                    />
                </div>
                <CustomRuleDialog isRuleDialog={false} hidden={!showNewRuleSetDialog} onToggleDialog={onToggleNewRuleSetDialog}></CustomRuleDialog>
            </div>
                </PivotItem>
                <PivotItem headerText="Undtagelse for eurocode" itemKey={TAB_EUROCODE}>
                    <EurocodeExceptions />
                </PivotItem>
            </Pivot>
        </>
    );
};

export default DepartmentRuleSet;
